import { useFetch } from '../../../hooks/useFetch';
import { customerService } from '../services/customerService';
import type { Customer } from '../types/customerTypes';

/** One customer by id; `id` undefined (new customer) resolves to null without a request. */
export function useCustomer(id?: string) {
  return useFetch<Customer | null>(() => (id ? customerService.get(id) : Promise.resolve(null)), [id]);
}
